import React, { Component } from 'react';
import styled from 'styled-components';

import { baseFont } from 'utils/fonts';
import colors from 'utils/colors';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 400px;
`;

const Box = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100px;
  height: 60px;
`;

const Num = styled.span`
  color: #c15d26;
  font-family: ${baseFont};
  font-size: 20px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
`;

const Subtitle = styled.span`
  color: #083e66;
  font-family: ${baseFont};
  font-size: 14px;
  line-height: 17px;
  text-align: center;
`;

class SystemActivity extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data } = this.props;
    return (
      <Wrapper>
        <Box>
          <Num>{data.avgdeliveries}</Num>
          <Subtitle>
            Average
            <br /> Daily Deliveries
          </Subtitle>
        </Box>
        <Box>
          <Num>{data.avgstorage} hrs</Num>
          <Subtitle>
            Average
            <br /> Storage Time
          </Subtitle>
        </Box>
      </Wrapper>
    );
  }
}

export default SystemActivity;



// WEBPACK FOOTER //
// ./src/common/d3/SystemActivity.js